import * as tslib_1 from "tslib";
import { Expose } from "class-transformer";
import { NatModel, NatProperty, NatHierarchical, NatRelation } from "@natiwi/core/decorators/matadata.decorator";
import { OrmObjectItem } from "@natiwi/core/models/object-item";
import { OrmEnumerationItem } from "@natiwi/shared/models/enumeration-item.model";
import { OrmSamplingSchemeFieldItem } from "@natiwi/core/models/sampling-scheme/sampling-scheme-field-item.model";
let OrmSamplingSchemePresetGroupFieldItem = class OrmSamplingSchemePresetGroupFieldItem extends OrmObjectItem {
    constructor() {
        super();
    }
    get enabled() {
        return this._enabled;
    }
    set enabled(v) {
        let oldValue = this._enabled;
        this._enabled = v;
        super.notifyFieldChange('enabled', oldValue, v);
    }
    get groupType() {
        return this._groupType;
    }
    set groupType(v) {
        let oldValue = this._groupType;
        this._groupType = v;
        super.notifyFieldChange('groupType', oldValue, v);
    }
    get field() {
        return this._field;
    }
    set field(v) {
        let oldValue = this._field;
        this._field = v;
        super.notifyFieldChange('field', oldValue, v);
    }
    get fieldValue() {
        return this._field;
    }
    set fieldValue(v) {
        let oldValue = this._field;
        this._field = v;
        super.notifyFieldChange('field', oldValue, v);
    }
};
tslib_1.__decorate([
    NatProperty({
        displayName: 'Используется',
        type: 'boolean',
        required: false,
        standart: false
    })
], OrmSamplingSchemePresetGroupFieldItem.prototype, "_enabled", void 0);
tslib_1.__decorate([
    NatProperty({
        displayName: 'Тип группировки',
        type: 'enumeration',
        enumerationType: 'OrmEnumerationItem',
        enumerationId: 'sampling_scheme_group_types',
        required: false,
        standart: false
    })
], OrmSamplingSchemePresetGroupFieldItem.prototype, "_groupType", void 0);
tslib_1.__decorate([
    NatProperty({
        displayName: 'Поле',
        type: 'relation',
        relationType: 'embedsOne',
        relationModel: 'OrmSamplingSchemeFieldItem',
        required: false,
        standart: false
    })
], OrmSamplingSchemePresetGroupFieldItem.prototype, "_field", void 0);
tslib_1.__decorate([
    Expose()
], OrmSamplingSchemePresetGroupFieldItem.prototype, "enabled", null);
tslib_1.__decorate([
    Expose(),
    NatRelation(OrmEnumerationItem)
], OrmSamplingSchemePresetGroupFieldItem.prototype, "groupType", null);
tslib_1.__decorate([
    Expose(),
    NatRelation(OrmSamplingSchemeFieldItem)
], OrmSamplingSchemePresetGroupFieldItem.prototype, "field", null);
tslib_1.__decorate([
    Expose(),
    NatRelation(OrmSamplingSchemeFieldItem)
], OrmSamplingSchemePresetGroupFieldItem.prototype, "fieldValue", null);
OrmSamplingSchemePresetGroupFieldItem = tslib_1.__decorate([
    NatModel({
        displayName: 'Элемент группировки',
        pluralDisplayName: 'Элементы группировкии'
    }),
    NatHierarchical(false)
], OrmSamplingSchemePresetGroupFieldItem);
export { OrmSamplingSchemePresetGroupFieldItem };
